<template>
    <div class="step-second table-padding-0">
        <Table :columns="columns" :data="orderData" :loading="tableLoading">
            <template slot-scope="{ row, index }" slot="deletebtn">
                <span class="delete-btn" @click="deleteProduct(index)">删除</span>
            </template>
            <template slot-scope="{ row }" slot="productCount">
                <Input
                    v-model="row.productCount"
                    type="number"
                    :disabled="$route.query.projectId && (row.supplyCount > 0) ? true : false"
                    @on-change="numberChange(row)"
                    @on-blur="setTotalValue(row)"
                    class="input-number"/>
            </template>
            <template slot-scope="{ row }" slot="unitPrice">
                <Input
                    v-model="row.unitPrice"
                    type="number"
                    :disabled="($route.query.projectId && (row.disabled > 0) || (projectStatus !== '1' && quotationStatus === '1' && (row.disabled > 0))) ? true : false"
                    @on-change="unitPriceChange(row)"
                    @on-blur="setTotalValue(row)"
                    class="input-number"/>
            </template>
            <template slot-scope="{ row }" slot="totalPrice">
                <span v-if="$route.query.projectId && Number(row.supplyCount) > 0">{{row.totalPrice}}</span>
                <Input
                    v-model="row.totalPrice"
                    v-else
                    type="number"
                    @on-change="totalPriceChange(row)"
                    @on-blur="setTotalValue(row)"
                    class="input-number"/>
            </template>
        </Table>
        <Row class="table-footer" type="flex" justify="end">
            <div class="monry-detail-info">
                <span>
                    共： <b class="weight"> {{ orderData.length }} </b>项
                </span>
                <span>
                    计： <b class="weight"> {{ submitVariables.count }} </b>件
                </span>
                <span>
                    金额合计： <b class="weight"> ￥{{ submitVariables.priceSum }} </b>元
                </span>
            </div>
        </Row>

        <div class="step-second-sub">
            <Button class="prev-step" @click="goBackPrev(1)" v-if="!$route.query.projectId">返回上一步</Button>
            <Button class="prev-step" @click="goBackPrev(2)" v-else>返回</Button>
            <Button class="prev-step" :loading="saveloading" @click="saveOrder" v-if="!$route.query.modify">
                <span v-if="!saveloading">保存</span>
                <span v-else>保存中...</span>
            </Button>
            <Button type="primary" @click="submitOrder" :disabled="isDisable">提交订单</Button>
        </div>
    </div>
</template>

<script>
import { createOriginalInfo, modifyOriginalInfo, saveDraft, getAllSettleChannel, updateOriginalSync, getOneProject, getProjectSupply, getQuotationPrice } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import NP from 'number-precision';
import { clone } from '@/assets/js/clone.js';
import { cliqueNoData } from '@/assets/js/data.js';
export default {
    data() {
        let _self = this;
        return {
            columns: [
                {
                    title: '#',
                    key: 'deletebtn',
                    slot: 'deletebtn',
                    minWidth: 60
                },
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 130
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 90
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '物资分类',
                    key: 'classifyname',
                    minWidth: 100
                },
                {
                    title: '数量',
                    key: 'productCount',
                    minWidth: 100,
                    slot: 'productCount'
                },
                {
                    title: '单价（元）',
                    key: 'unitPrice',
                    minWidth: 100,
                    slot: 'unitPrice'
                },
                {
                    title: '金额（元）',
                    key: 'totalPrice',
                    minWidth: 120,
                    slot: 'totalPrice'
                }
            ],

            orderData: [],

            // 提交参数项
            submitVariables: {
                originalItemsInput: [],
                originCreateType: 1,
                supplierNo: '',
                settleChannel: '',
                cliqueNo: '',
                organNo: '',
                serialCount: 0,
                count: 0,
                priceSum: 0
            },
            isDisable: false,
            saveloading: false,
            projectId: '', // 计划单号
            receiptInfo: {},
            projectStatus: '',
            quotationStatus: '',
            tableLoading: false,
            timer: null
        };
    },

    computed: {
        listInfo() {
            let info = JSON.parse(decodeURI(window.sessionStorage.getItem('StepFirst')));
            if (info) {
                return info;
            } else {
                return '';
            }
        }
    },

    beforeMount() {
        this.$store.commit('setStep', 1);
        if (!this.$route.query.projectId) {
            this.getSelectionProduct();
        }
    },
    mounted() {
        this.projectId = this.$route.query.projectId;
        const quotationId = this.$route.query.quotation;
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        this.projectStatus = supplierFun.project1 > -1 ? '1' : '0';
        this.quotationStatus = supplierFun.quotation > -1 ? '1' : '0';
        if (this.projectId) {
            this.columns = this.columns.slice(1);
            this.columns.splice(4, 0, {
                title: '可供应数量',
                key: 'supplyCount',
                minWidth: 100
            });
            if (this.$route.query.isLocked === '1') {
                this.$Notice.open({
                    title: '此计划为锁定状态,请稍后再操作',
                    duration: 10
                });
            }
            if (this.$route.query.type === 'jh' || this.$route.query.type === 'home') {
                this.getOneProject();
            } else {
                // 修改新增物资
                const arr = JSON.parse(sessionStorage.getItem('projectIsModify'));
                arr.forEach(item => {
                    if (item.productName) {
                        item.productname = item.productName;
                        item.productno = item.productNo;
                        item.productspu = item.spu;
                        item.productspectype = item.productSpectype;
                        item.productspec = item.productUnit;
                        item.classifyname = item.classifyName;
                        item.unitPrice = item.unitPrice;
                        item.disabled = item.price2 ? Number(item.price2) : Number(item.price1);
                        if (item.supplyCount !== null) {
                            if (this.$route.query.modify) {
                                if (Number(item.supplyCount) > 0) {
                                    item.productCount = Number(item.productCount).toFixed(3);
                                    item.supplyCount = Number(item.supplyCount).toFixed(3);
                                } else {
                                    item.productCount = item.productCount;
                                    item.supplyCount = item.productCount;
                                }
                            } else {
                                item.productCount = Number(item.supplyCount).toFixed(3);
                                item.supplyCount = Number(item.supplyCount).toFixed(3);
                            }
                        } else {
                            item.productCount = item.productCount;
                            item.supplyCount = item.productCount;
                        }
                        item.totalPrice = Number(NP.round(NP.times(+item.unitPrice, +item.productCount), 2)).toFixed(2);
                    }
                });
                this.listInfo.rightData.forEach(item => {
                    item.productNo = item.productno;
                    arr.forEach(last => {
                        if (last.productNo === item.productNo) {
                            item.unitPrice = last.unitPrice;
                            item.disabled = Number(item.unitPrice);
                            if (last.supplyCount !== null) {
                                item.productCount = Number(last.productCount).toFixed(3);
                                item.supplyCount = Number(last.supplyCount).toFixed(3);
                            } else {
                                item.supplyCount = last.productCount;
                                item.productCount = last.productCount;
                            }
                            item.totalPrice = Number(NP.round(NP.times(+item.unitPrice, +item.productCount), 2)).toFixed(2);
                        }
                    });
                });
                const st = this.listInfo.rightData.filter(n => !arr.map(v => v.productNo).includes(n.productNo));
                if (st.length) {
                    this.$apollo.query({
                        query: getProjectSupply,
                        context: { useApi1: false },
                        variables: {
                            projectId: this.$route.query.projectId.toString()
                        },
                        fetchPolicy: 'network-only'
                    }).then(res => {
                        const data = res.data.getProjectSupply;
                        if (data && data.code === 200) {
                            if (data.data.length) {
                                st.forEach(last => {
                                    data.data.forEach(sub => {
                                        if (sub.productNo === last.productNo) {
                                            last.unitPrice = sub.unitPrice1 ? sub.unitPrice1 : sub.unitPrice2;
                                            last.disabled = Number(last.unitPrice);
                                            last.type = 3;
                                            if (sub.supplyCount !== null) {
                                                last.supplyCount = Number(sub.supplyCount).toFixed(3);
                                                last.productCount = Number(sub.supplyCount).toFixed(3);
                                            } else {
                                                last.supplyCount = sub.productCount;
                                                last.productCount = sub.productCount;
                                            }
                                            last.totalPrice = Number(NP.round(NP.times(+last.unitPrice, +last.productCount), 2)).toFixed(2);
                                        }
                                    });
                                });
                            }
                            this.orderData = this.listInfo.rightData;
                            this.submitVariables.serialCount = this.orderData.length;
                            let count = 0;
                            let priceSum = 0;
                            this.orderData.forEach(ele => {
                                count += Number(ele.productCount);
                                priceSum += Number(ele.totalPrice);
                            });
                            this.submitVariables.count = count.toFixed(3);
                            this.submitVariables.priceSum = priceSum.toFixed(2);
                        }
                    }).catch(error => {
                        if (error) {
                            this.$setNotice('服务繁忙，请稍后刷新');
                        }
                    });
                } else {
                    this.orderData = this.listInfo.rightData;
                    this.submitVariables.serialCount = this.orderData.length;
                    let count = 0;
                    let priceSum = 0;
                    this.orderData.forEach(ele => {
                        count += Number(ele.productCount);
                        priceSum += Number(ele.totalPrice);
                    });
                    this.submitVariables.count = count.toFixed(3);
                    this.submitVariables.priceSum = priceSum.toFixed(2);
                }
                this.submitVariables.cliqueNo = Cookies.getJSON('cliqueNo').toString();
                this.submitVariables.supplierNo = Cookies.getJSON('USER-INFO').supplierNo;
                this.submitVariables.organNo = this.listInfo.department[this.listInfo.department.length - 1];
                this.submitVariables.settleChannel = this.listInfo.settleChannel;
            }
        }
        if (quotationId) {
            this.getQuotationPrice(quotationId);
        }
    },
    methods: {
        async getOneProject() {
            this.tableLoading = true;
            await this.$apollo.query({
                query: getOneProject,
                context: { useApi1: false },
                variables: {
                    projectId: this.$route.query.projectId
                },
                fetchPolicy: 'network-only'
            }).then(async res => {
                const data = res.data.getOneProject;
                if (data && data.code === 200) {
                    this.receiptInfo = data.data;
                    this.submitVariables.count = 0;
                    this.submitVariables.priceSum = 0;
                    this.submitVariables.cliqueNo = Cookies.getJSON('cliqueNo').toString();
                    this.submitVariables.supplierNo = Cookies.getJSON('USER-INFO').supplierNo;
                    this.submitVariables.organNo = this.receiptInfo.organNo;
                    await this.$apollo.query({
                        query: getProjectSupply,
                        context: { useApi1: false },
                        variables: {
                            projectId: this.$route.query.projectId.toString()
                        },
                        fetchPolicy: 'network-only'
                    }).then(res => {
                        const data = res.data.getProjectSupply;
                        this.tableLoading = false;
                        if (data && data.code === 200) {
                            this.orderData = [];
                            if (data.data.length) {
                                this.receiptInfo.items.forEach(item => {
                                    data.data.forEach(sub => {
                                        if (item.productNo === sub.productNo) {
                                            if (sub.supplyCount !== null) {
                                                if (Number(sub.supplyCount) > 0) {
                                                    this.orderData.push({
                                                        serialNum: sub.serialNum,
                                                        productname: sub.productName,
                                                        productno: sub.productNo,
                                                        productspectype: sub.productSpectype,
                                                        classifyname: sub.classifyName,
                                                        productCount: Number(sub.supplyCount).toFixed(3),
                                                        supplyCount: Number(sub.supplyCount).toFixed(3),
                                                        unitPrice: sub.unitPrice1 ? sub.unitPrice1 : sub.unitPrice2,
                                                        totalPrice: sub.unitPrice1 ? Number(NP.round(NP.times(+sub.unitPrice1, +sub.supplyCount), 2)).toFixed(2) : Number(NP.round(NP.times(+sub.unitPrice2, +sub.supplyCount), 2)).toFixed(2),
                                                        disabled: sub.unitPrice1 ? Number(sub.unitPrice1) : Number(sub.unitPrice2),
                                                        type: 3
                                                    });
                                                }
                                            } else {
                                                this.orderData.push({
                                                    serialNum: sub.serialNum,
                                                    productname: sub.productName,
                                                    productno: sub.productNo,
                                                    productspectype: sub.productSpectype,
                                                    classifyname: sub.classifyName,
                                                    productCount: Number(sub.productCount).toFixed(3),
                                                    supplyCount: Number(sub.productCount).toFixed(3),
                                                    unitPrice: sub.unitPrice1 ? sub.unitPrice1 : sub.unitPrice2,
                                                    totalPrice: sub.unitPrice1 ? Number(NP.round(NP.times(+sub.unitPrice1, +sub.productCount), 2)).toFixed(2) : Number(NP.round(NP.times(+sub.unitPrice2, +sub.productCount), 2)).toFixed(2),
                                                    disabled: sub.unitPrice1 ? Number(sub.unitPrice1) : Number(sub.unitPrice2),
                                                    type: 3
                                                });
                                            }
                                        }
                                    });
                                });
                            }
                            if (!this.orderData.length) {
                                this.$setNotice('无可供应数量');
                            }
                            let count = 0;
                            let priceSum = 0;
                            this.orderData.forEach(ele => {
                                count += Number(ele.productCount);
                                priceSum += Number(ele.totalPrice);
                            });
                            this.submitVariables.serialCount = this.orderData.length;
                            this.submitVariables.count = count.toFixed(3);
                            this.submitVariables.priceSum = priceSum.toFixed(2);
                        }
                    }).catch(error => {
                        this.tableLoading = false;
                        if (error) {
                            this.$setNotice('服务繁忙，请稍后重试');
                        }
                    });
                    await this.$apollo.query({
                        query: getAllSettleChannel,
                        variables: {
                            cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                            all: 0
                        },
                        fetchPolicy: 'network-only'
                    }).then(res => {
                        const result = res.data.getAllSettleChannel;
                        result.data.forEach(item => {
                            if (item.name === this.receiptInfo.settleChannel) {
                                this.submitVariables.settleChannel = item.alias;
                            }
                        });
                    }).catch(error => {
                        if (error) {
                            this.$setNotice('服务繁忙，请稍后重试');
                        }
                    });
                }
            }).catch(error => {
                this.tableLoading = true;
                if (error) {
                    this.$setNotice('服务繁忙，请稍后重试');
                }
            });
        },
        getQuotationPrice(id) {
            this.$apollo.query({
                query: getQuotationPrice,
                context: { useApi1: false },
                variables: {
                    quotationNo: id
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getQuotationPrice;
                if (data && data.code === 200) {
                    this.listInfo.rightData.forEach(item => {
                        item.productNo = item.productno;
                        item.type = 1;
                        if (data.data.length) {
                            data.data.forEach(last => {
                                if (last.productNo === item.productNo) {
                                    item.unitPrice = last.price;
                                    item.disabled = Number(item.unitPrice);
                                    item.type = 2;
                                }
                            });
                        } else {
                            item.unitPrice = '';
                            item.disabled = 0;
                            item.type = 1;
                        }
                    });
                }
            });
        },
        // 获取选取物资
        getSelectionProduct() {
            if (this.listInfo.rightData) {
                this.listInfo.rightData.forEach((ele, k) => {
                    ele.serialNum = k + 1;
                });
                this.orderData = this.listInfo.rightData;
                // 项数
                this.submitVariables.serialCount = this.orderData.length;

                let count = 0;
                let priceSum = 0;
                this.orderData.forEach(ele => {
                    count += Number(ele.productCount);
                    priceSum += Number(ele.totalPrice);
                });
                this.submitVariables.count = count.toFixed(3);
                this.submitVariables.priceSum = priceSum.toFixed(2);

                this.submitVariables.cliqueNo = Cookies.getJSON('cliqueNo').toString();
                this.submitVariables.supplierNo = Cookies.getJSON('USER-INFO').supplierNo;
                this.submitVariables.organNo = this.listInfo.department[this.listInfo.department.length - 1];
                this.submitVariables.settleChannel = this.listInfo.settleChannel;
                this.submitVariables.quotationNo = this.listInfo.selectQuotation;
            }
        },

        // 金额 变化
        totalPriceChange(val) {
            if (Number(val.productCount) > 0) {
                if (val.disabled > 0) {
                    if (Number(val.productCount) > Number(val.supplyCount)) {
                        val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                    } else {
                        val.productCount = NP.round(NP.divide(+val.totalPrice, +val.unitPrice), 3);
                    }
                } else {
                    if (val.supplyCount && (Number(val.productCount) > Number(val.supplyCount))) {
                        val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                    } else {
                        val.unitPrice = NP.round(NP.divide(+val.totalPrice, +val.productCount), 2);
                    }
                }
                this.orderData[val._index] = val;
            } else {
                val.productCount = 0;
                this.orderData[val._index] = val;
            }
        },

        // 单价 变化
        unitPriceChange(val) {
            if (Number(val.unitPrice) > 0) {
                val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                this.orderData[val._index] = val;
            } else {
                val.unitPrice = 0;
                val.totalPrice = 0;
                this.orderData[val._index] = val;
            }
        },

        // 数量 变化
        numberChange(val) {
            if (Number(val.productCount) > 0) {
                val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                this.orderData[val._index] = val;
            } else {
                val.productCount = 0;
                val.totalPrice = 0;
                this.orderData[val._index] = val;
            }
        },

        // 总计值
        setTotalValue(val) {
            if (this.projectId) {
                if (Number(val.supplyCount) > 0) {
                    if (Number(val.productCount) > Number(val.supplyCount)) {
                        val.productCount = val.supplyCount;
                        val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                        this.$setNotice('填写数量应小于可供应数量');
                    }
                } else {
                    this.$setNotice('无可供应数量');
                    val.productCount = 0;
                    val.totalPrice = 0;
                }
            }
            val.productCount = Number(val.productCount).toFixed(3);
            val.unitPrice = Number(val.unitPrice).toFixed(2);
            val.totalPrice = Number(NP.round(NP.times(+val.unitPrice, +val.productCount), 2)).toFixed(2);
            // val.totalPrice = Number(val.totalPrice).toFixed(2);
            let count = 0;
            let priceSum = 0;
            this.orderData.forEach(ele => {
                count += Number(ele.productCount);
                priceSum += Number(ele.totalPrice);
            });
            this.submitVariables.count = count.toFixed(3);
            this.submitVariables.priceSum = priceSum.toFixed(2);
        },

        // 返回上一步
        goBackPrev(s) {
            if (s === 1) {
                this.listInfo.rightData = this.orderData;
                let datas = encodeURI(JSON.stringify(this.listInfo));
                window.sessionStorage.setItem('StepFirst', datas);
                this.$store.commit('setStep', 0);
                this.$router.go(-1);
            } else {
                this.$store.commit('setStep', 0);
                this.$router.go(-1);
            }
        },

        // 提交订单
        async submitOrder() {
            if (this.orderData.length) {
                // 重构符合参数要求的数组
                this.isDisable = true;
                let originalItemsInputCont = [];
                let adopt = true;
                this.orderData.forEach((ele, index) => {
                    if (ele.productno) {
                        ele.productNo = ele.productno;
                    }
                    originalItemsInputCont.push({
                        productCount: ele.productCount,
                        unitPrice: ele.unitPrice,
                        totalPrice: ele.totalPrice,
                        productNo: ele.productNo,
                        serialNum: index + 1,
                        type: ele.type
                    });
                });
                originalItemsInputCont.forEach(ele => {
                    ele.serialNum = Number(ele.serialNum);
                    if (Number(ele.productCount) <= 0 || Number(ele.totalPrice) <= 0 || Number(ele.unitPrice) <= 0) {
                        adopt = false;
                    }
                });
                if (adopt) {
                    this.submitVariables.originalItemsInput = originalItemsInputCont;
                    let newsubmitVariables = clone(this.submitVariables);
                    // 重新修改
                    if (this.$route.query.originNo && !this.$route.query.draft) {
                        delete this.submitVariables.cliqueNo;
                        delete this.submitVariables.supplierNo;
                        delete this.submitVariables.originCreateType;
                        await this.$apollo.mutate({
                            mutation: modifyOriginalInfo,
                            variables: {
                                originNo: this.$route.query.originNo,
                                modifyInfo: this.submitVariables
                            }
                        }).then(async res => {
                            const data = res.data.modifyOriginalInfo;
                            this.isDisable = false;
                            if (data && data.code === 200) {
                                this.$setNotice(data.message);
                                this.$store.commit('setStep', 2);
                                window.sessionStorage.removeItem('StepFirst');
                                const cliqueNo = cliqueNoData;
                                const isClique = cliqueNo.indexOf(Cookies.getJSON('cliqueNo').toString()) > -1;
                                if (isClique) {
                                    await this.$apollo.mutate({
                                        mutation: updateOriginalSync,
                                        variables: {
                                            originNo: this.$route.query.originNo
                                        }
                                    }).then(res => {
                                        const data = res.data.updateOriginalSync;
                                        if (data && data.code === 200) {
                                            this.$router.push('/index');
                                        } else {
                                            this.$Notice.open({
                                                title: '提示',
                                                desc: data.message,
                                                duration: 10
                                            });
                                        }
                                    }).catch(error => {
                                        if (error) {
                                            this.$setNotice('服务繁忙，同步失败');
                                        }
                                    });
                                } else {
                                    this.$router.push('/index');
                                }
                            } else {
                                this.isDisable = false;
                                this.$setNotice(data.message);
                            }
                        }).catch(error => {
                            this.isDisable = false;
                            if (error) {
                                this.$setNotice('服务繁忙，请稍后重试');
                            }
                        });
                    } else {
                        if (this.$route.query.draft) {
                            this.submitVariables.originNo = this.$route.query.originNo;
                        }
                        if (this.$route.query.projectId) {
                            this.submitVariables.projectId = this.$route.query.projectId;
                        } else {
                            this.submitVariables.projectId = '';
                        }
                        if (this.$route.query.isLocked === '1') {
                            this.$Notice.open({
                                title: '此计划为锁定状态,请稍后再操作',
                                duration: 5
                            });
                        } else {
                            await this.$apollo.mutate({
                                mutation: createOriginalInfo,
                                variables: {
                                    originalInfo: this.submitVariables
                                }
                            }).then(async res => {
                                const data = res.data.createOriginalInfo;
                                if (data && data.code === 200) {
                                    this.isDisable = false;
                                    this.$setNotice(data.message);
                                    this.$store.commit('setStep', 2);
                                    window.sessionStorage.removeItem('StepFirst');
                                    window.sessionStorage.removeItem('projectIsModify');
                                    this.$Notice.open({
                                        title: '提交成功',
                                        desc: '订单号： ' + data.data,
                                        duration: 30
                                    });
                                    const cliqueNo = cliqueNoData;
                                    const isClique = cliqueNo.indexOf(Cookies.getJSON('cliqueNo').toString()) > -1;
                                    if (isClique) {
                                        await this.$apollo.mutate({
                                            mutation: updateOriginalSync,
                                            variables: {
                                                originNo: data.data
                                            }
                                        }).then(res => {
                                            const data = res.data.updateOriginalSync;
                                            if (data && data.code === 200) {
                                                if (this.$route.query.draft) {
                                                    this.$router.push('/index/draft');
                                                } else if (this.$route.query.projectId && this.$route.query.type === 'jh') {
                                                    this.$router.push('/index/plan_price');
                                                } else {
                                                    this.$router.push('/index');
                                                }
                                            } else {
                                                this.$Notice.open({
                                                    title: '提示',
                                                    desc: data.message,
                                                    duration: 10
                                                });
                                            }
                                        }).catch(error => {
                                            if (error) {
                                                this.$setNotice('服务繁忙，同步失败');
                                            }
                                        });
                                    } else {
                                        if (this.$route.query.draft) {
                                            this.$router.push('/index/draft');
                                        } else if (this.$route.query.projectId && this.$route.query.type === 'jh') {
                                            this.$router.push('/index/plan_price');
                                        } else {
                                            this.$router.push('/index');
                                        }
                                    }
                                } else {
                                    this.$setNotice(data.message);
                                    this.isDisable = false;
                                }
                            }).catch(error => {
                                this.isDisable = false;
                                if (error) {
                                    this.$setNotice('服务繁忙，请稍后重试');
                                }
                            });
                        }
                    }
                } else {
                    this.$setNotice('数量/单价/金额不能为0');
                    this.isDisable = false;
                }
            }
        },
        // 删除物资
        deleteProduct(index) {
            let count = 0;
            let priceSum = 0;
            this.orderData.splice(index, 1);
            this.orderData.forEach((ele, idx) => {
                count += Number(ele.productCount); // 件数
                priceSum += Number(ele.totalPrice); // 总金额
                ele.serialNum = idx + 1;
            });
            this.submitVariables.serialCount = this.orderData.length;
            this.submitVariables.count = count.toFixed(3);
            this.submitVariables.priceSum = priceSum.toFixed(2);
        },
        // 保存
        saveOrder() {
            if (this.orderData.length) {
                let originalItemsInputCont = [];
                this.orderData.forEach((item, index) => {
                    if (item.productno) {
                        item.productNo = item.productno;
                    }
                    // 价格来源；1:手动输入,2:询价单带入,3:计划带入
                    originalItemsInputCont.push({
                        productCount: item.productCount.toString(),
                        unitPrice: item.unitPrice.toString(),
                        totalPrice: item.totalPrice.toString(),
                        productNo: item.productNo.toString(),
                        serialNum: index + 1,
                        type: item.type
                    });
                });
                this.submitVariables.originalItemsInput = originalItemsInputCont;
                if (this.$route.query.originNo) {
                    this.submitVariables.originNo = this.$route.query.originNo;
                } else {
                    this.submitVariables.originNo = '';
                }
                if (this.$route.query.projectId) {
                    this.submitVariables.projectId = this.$route.query.projectId;
                } else {
                    this.submitVariables.projectId = '';
                }
                if (this.$route.query.isLocked === '1') {
                    this.$Notice.open({
                        title: '此计划为锁定状态,请稍后再操作',
                        duration: 5
                    });
                } else {
                    this.listInfo.rightData = this.orderData;
                    let datas = encodeURI(JSON.stringify(this.listInfo));
                    window.sessionStorage.setItem('StepFirst', datas);
                    this.saveloading = true;
                    this.$apollo.mutate({
                        mutation: saveDraft,
                        variables: {
                            originalInfo: this.submitVariables
                        }
                    }).then(res => {
                        this.saveloading = false;
                        const data = res.data.saveDraft;
                        if (data && data.code === 200) {
                            this.$setNotice(data.message);
                        } else {
                            this.$setNotice(data.message);
                        }
                    }).catch(error => {
                        this.saveloading = false;
                        if (error) {
                            this.$setNotice('服务繁忙，请稍后重试');
                        }
                    });
                }
            }
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ManualBuildReceipt/stepSecond.vue